import { StyleSheet, Platform } from 'react-native';
import { getResponsiveValue } from './breakpoints';
import { colors } from './theme';

export const homeStyles = StyleSheet.create({
  homeContent: {
    flex: 1,
    width: '100%',
    minHeight: '100dvh',
    alignSelf: 'center',
    paddingHorizontal: getResponsiveValue({
      mobile: 20,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    paddingTop: getResponsiveValue({
      mobile: 0,
      tablet: 12,
      laptop: 12,
      desktop: 12
    }),
    bottom: 100,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    overflow: 'visible',
    maxWidth: '100vw',
  },
  homeCard: {
    backgroundColor: 'rgba(102, 103, 105, 0.5)',
    borderRadius: 10,
    padding: getResponsiveValue({
      mobile: 20,
      tablet: 30,
      laptop: 40,
      desktop: 40
    }),
    alignItems: 'center',
    justifyContent: 'center',
    height: getResponsiveValue({
      mobile: 400,
      tablet: 450,
      laptop: 510,
      desktop: 510
    }),
    width: getResponsiveValue({
      mobile: '100%',
      tablet: '80%',
      laptop: '70%',
      desktop: '60%'
    }),
    alignSelf: 'center',
    margin: 'auto',
    maxWidth: 1200,
    backdropFilter: Platform.OS === 'web' ? 'blur(20px)' : undefined,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  homeTitle: {
    fontFamily: 'DazHandwriting',
    fontWeight: '900',
    fontSize: getResponsiveValue({
      mobile: '2.4rem',
      tablet: '3.2rem',
      laptop: '3.8rem',
      desktop: '4.4rem'
    }),
    color: '#c7cc4c',
    textAlign: 'center',
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  homeSubtitle: {
    fontFamily: 'VastagoGrotesk',
    fontWeight: '500',
    fontSize: getResponsiveValue({
      mobile: '1rem', // ~16px
      tablet: '1.25rem', // ~20px
      laptop: '1.75rem', // ~28px
      desktop: '2.125rem' // ~34px
    }),
    color: '#000000',
    textAlign: 'center',
    width: '100%',
    maxWidth: 800,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: getResponsiveValue({
      mobile: 30,
      tablet: 20,
      laptop: 20,
      desktop: 20
    }),
    textShadow: Platform.OS === 'web' ? '0px 2px 2px rgba(0,0,0,0.25)' : undefined,
  },
  homeSubtitle2: {
    fontFamily: 'Glacial Indifference',
    fontWeight: '400',
    color: '#429277',
    fontSize: getResponsiveValue({
      mobile: '1rem', // ~16px
      tablet: '1.25rem', // ~20px
      laptop: '1.75rem', // ~28px
      desktop: '2.125rem' // ~34px
    }),
  },
  searchContainer: {
    width: '100%',
    maxWidth: getResponsiveValue({
      mobile: '100%',
      tablet: 600,
      laptop: 800,
      desktop: 900
    }),
    minWidth: getResponsiveValue({
      mobile: '100%',
      tablet: '80%',
      laptop: '60%',
      desktop: '50%'
    }),
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    zIndex: 4,
    alignSelf: 'center',
    borderBottomWidth: 1,
  },
  searchIcon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    height: 20,
    width: 20,
    zIndex: 10,
  },
  searchInput: {
    fontFamily: 'VastagoGrotesk',
    backgroundColor: 'transparent',
    color: '#000000',
    width: '100%',
    fontSize: getResponsiveValue({
      mobile: 16,
      tablet: 18,
      laptop: 20,
      desktop: 22,
    }),
    height: getResponsiveValue({
      mobile: 50,
      tablet: 60,
      laptop: 50,
      desktop: 60,
    }),
    paddingHorizontal: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 30,
      desktop: 30,
    }),
    paddingRight: getResponsiveValue({
      mobile: 50,
      tablet: 60,
      laptop: 60,
      desktop: 70,
    }),
    ...(Platform.OS === 'web' && {
      outlineStyle: 'none',
      border: 'none',
    }),
  },
  locationIconContainer: {
    position: 'absolute',
    right: getResponsiveValue({
      mobile: 20,
      tablet: 25,
      laptop: 25,
      desktop: 30,
    }),
    top: '50%',
    transform: Platform.OS === 'web' ? 'translateY(-50%)' : undefined,
    height: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    width: getResponsiveValue({
      mobile: 30,
      tablet: 40,
      laptop: 40,
      desktop: 40,
    }),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      ':hover': {
        transform: 'translateY(-50%) scale(1.1)',
      },
    }),
  },
  svgIcon: {
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  locationDot: {
    position: 'absolute',
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#000000',
    zIndex: 2,
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
  locationRing: {
    position: 'absolute',
    width: 18,
    height: 18,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: '#000000',
    backgroundColor: 'transparent',
    top: '50%',
    left: '50%',
    transform: Platform.OS === 'web' ? 'translate(-50%, -50%)' : undefined,
  },
}); 